/**
* Web Service handler to send updated resource availability to the service
*
* @class UpdateResourceAvailabilityWS
*/
var UpdateResourceAvailabilityWS = function (parent) {
	var self = this; // Convenience reference so the context of 'this' becomes clearer

	// Predicate this Web Service handler on the Abstract class of a Web
	// Service handler. This establishes core functionality required of
	// these such handlers, which can be overwritten by methods below.
	AbstractWS.apply( this, arguments );

	self.availabilityModel	= ko.observable( null );
	self.dataType			= 'json';
	self.name				= 'UpdateResourceAvailabilityWS'; // Convenience name for debugging
	self.resourceId			= ko.observable( null );


	/**
	* API Endpoint
	*
	* @method serviceURL
	* @return {String | Null}
	*/
	self.serviceURL	= ko.computed( function () {
		if ( self.resourceId() != null && self.availabilityModel() != null ) {
			return '/qlessConfig/api/v1/config/availability/' + self.resourceId() + '/' + self.availabilityModel().id;
		}

		return null;
	});


	/**
	* This method requests data from the service
	*
	* @method doRequest
	* @param {Function} fCallback Function to be run once data has been processed
	* @return {UpdateResourceAvailabilityWS} Returns the object as chainable, for best practice
	*/
	self.doRequest = function ( fCallback ) {
		// Prevent requests without a resource ID from hitting the service
		if ( self.resourceId() != null ) {
			qcal.setStatusMessage('Requesting resource availability');

			// Call the super-method
			AbstractWS.prototype.doRequest.call( self, fCallback );
		}

		// Return self (UpdateResourceAvailabilityWS) to be chainable, for best practice
		return self;
	};


	/**
	* Method to pass a new AvailabilityModel to the web service
	*
	* @method create
	* @param {AvailabilityModel} oAvailabilityModel Model to create in the DB
	* @return {UpdateResourceAvailabilityWS} Returns the object as chainable, for best practice
	*/
	self.create = function ( oAvailabilityModel ) {
		var units = oAvailabilityModel.units.toUpperCase();

		self.serviceURL	= ko.computed( function () {
			return '/qlessConfig/api/v1/config/availability';
		});

		self.method('POST');

		self.clearParams();

		if ( units == 'MIN' ){
			units = 'MINUTES';
		}

		var params = {
			"duration" : oAvailabilityModel.duration(),
			"units" : units,
			"startHour" : oAvailabilityModel.startHour(),
			"startMinute" : oAvailabilityModel.startMinute(),
			"timeZone" : oAvailabilityModel.timeZone,
			"resourceId" : self.resourceId()
		};

		if ( oAvailabilityModel.daysOfWeek != null ) {
			params["daysOfWeek"] = oAvailabilityModel.dayBitMask();
		}

		if ( oAvailabilityModel.recurrenceStart != null ) {
			params["recurrenceStart"] = oAvailabilityModel.recurrenceStart;
		}

		if ( oAvailabilityModel.recurrenceEnd != null ) {
			params["recurrenceEnd"] = oAvailabilityModel.recurrenceEnd;
		}

		if ( oAvailabilityModel.recurrenceType() ) {
			params["recurrenceType"] = oAvailabilityModel.recurrenceType();
		}

		if (oAvailabilityModel.recurrenceType() == "nonRecurrent") {
			params["start"] = oAvailabilityModel.startDate();
			params["end"] = oAvailabilityModel.endDate();
		}

		self.params = JSON.stringify(params);

		AbstractWS.prototype.doRequest.call( self );

		// Return self (UpdateResourceAvailabilityWS) to be chainable, for best practice
		return self;
	}


	/**
	* Method to pass a new AvailabilityModel to the web service
	*
	* @method deleteAvail
	* @param {AvailabilityModel} oAvailabilityModel Model to remove
	* @return {UpdateResourceAvailabilityWS} Returns the object as chainable, for best practice
	*/
	self.deleteAvail = function ( oAvailabilityModel ) {
		if ( self.resourceId() != null && oAvailabilityModel != null ){

			self.serviceURL	= ko.computed( function () {
				return '/qlessConfig/api/v1/config/availability/' + self.resourceId() + '/' + oAvailabilityModel.id;
			});

			self.method('DELETE');

			AbstractWS.prototype.doRequest.call( self );

		}

		// Return self (UpdateResourceAvailabilityWS) to be chainable, for best practice
		return self;
	};


	/**
	* Method to update an AvailabilityModel's representation in the DB
	*
	* @method update
	* @param {AvailabilityModel} oAvailabilityModel Model to update
	* @return {UpdateResourceAvailabilityWS} Returns the object as chainable, for best practice
	*/
	self.update = function ( oAvailabilityModel ) {
		var units = '';

		if ( self.resourceId() != null && oAvailabilityModel != null ){

			self.serviceURL	= ko.computed( function () {
				return '/qlessConfig/api/v1/config/availability/' + self.resourceId() + '/' + oAvailabilityModel.id;
			});

			self.method('PUT');

			self.clearParams();

			units = oAvailabilityModel.units.toUpperCase();

			if ( units == 'MIN' ) {
				units = 'MINUTES';
			}
			else if ( units == 'HRS' ) {
				units = 'HOURS';
			}

			var params = {
				"id" : oAvailabilityModel.id,
				"duration" : oAvailabilityModel.duration(),
				"units" : units,
				"startHour" : oAvailabilityModel.startHour(),
				"startMinute" : oAvailabilityModel.startMinute(),
				"timeZone" : oAvailabilityModel.timeZone
			};

			if ( oAvailabilityModel.recurrenceStart != null ) {
				params["recurrenceStart"] = oAvailabilityModel.recurrenceStart;
			}

			if ( oAvailabilityModel.recurrenceEnd != null ) {
				params["recurrenceEnd"] = oAvailabilityModel.recurrenceEnd;
			}

			if ( oAvailabilityModel.recurrenceInterval() != null ) {
				params["recurrenceType"] = oAvailabilityModel.recurrenceType();
			}

			if (oAvailabilityModel.recurrenceType() == "nonRecurrent") {
				params["start"] = oAvailabilityModel.startDate();
				params["end"] = oAvailabilityModel.endDate();
			}

			params["daysOfWeek"] = oAvailabilityModel.dayBitMask();

			self.params = JSON.stringify(params);

			AbstractWS.prototype.doRequest.call( self );
		}

		// Return self (UpdateResourceAvailabilityWS) to be chainable, for best practice
		return self;
	};


	/**
	* This method evaluates the return data from the service call.
	*
	* @method processData
	* @param {JSON} jsonData JSON data returned from the service
	* @return {UpdateResourceAvailabilityWS} Returns the object as chainable, for best practice
	*/
	self.processData = function ( jsonData ) {
		var i = 0,
			aAvails = [],
			aTemp = [];

		qcal.setStatusMessage('Resource availability updated', 1000);

		if (qcal.getQueryParam('debug') == 'true') {
			console.log(jsonData);
		}

		// Call the superclass method to perform any core actions
		AbstractWS.prototype.processData.call( self, jsonData );

		// Return self (UpdateResourceAvailabilityWS) to be chainable, for best practice
		return self;
	};


	return self;
};

UpdateResourceAvailabilityWS.prototype = AbstractWS.prototype;
UpdateResourceAvailabilityWS.prototype.constructor = UpdateResourceAvailabilityWS;


if (typeof exports !== 'undefined') {
  exports.UpdateResourceAvailabilityWS = UpdateResourceAvailabilityWS;
}
